import { Box, Link, BoxProps } from '@mui/material';

import { appConfig } from '@app/app';
import { assets } from '@app/tenant';

export interface LogoLinkProps extends BoxProps {}

export const LogoLink = ({ sx, ...props }: LogoLinkProps) => {
  const logoImage = assets.logo;

  return (
    <Link
      sx={{
        display: 'inline-block',
        lineHeight: 1,
        verticalAlign: 'top',
        '&:hover, &:focus': {
          opacity: 0.9,
          textDecoration: 'none',
        },
      }}
      href={appConfig.appUrl}
    >
      <Box
        width={100}
        height={45}
        component="img"
        src={logoImage}
        alt="logo"
        {...props}
        // `sx` does not merge across the spread above, so it must come last AND absorb a caller's own
        // `sx` — either single position silently drops one of the two (SAA-181 D11).
        sx={[{ objectFit: 'contain' }, ...(Array.isArray(sx) ? sx : [sx ?? false])]}
      />
    </Link>
  );
};
